import standardDetailLayoutRoute from '@input-web/modules/standard/views/detail-layout/standard-detail-layout.route';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

const standardScoringDetailRoute = createRoute({
  component: lazyRouteComponent(() => import('./standard-scoring-detail.view')),
  getParentRoute: () => standardDetailLayoutRoute,
  path: '/scoring',
});

export default standardScoringDetailRoute;
